"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEditIssueActivity = exports.getCommentActivity = exports.getAssignedIssueActivity = exports.getRaisedIssueActivity = exports.createActivity = exports.IssueActivityEditableProperty = void 0;
const moment_timezone_1 = __importDefault(require("moment-timezone"));
const ActivityType_1 = __importDefault(require("../ActivityType"));
// eslint-disable-next-line no-shadow
var IssueActivityEditableProperty;
(function (IssueActivityEditableProperty) {
    IssueActivityEditableProperty["TYPE"] = "type";
    IssueActivityEditableProperty["STATUS"] = "status";
    IssueActivityEditableProperty["DEADLINE_DATE"] = "deadlineDate";
    IssueActivityEditableProperty["FLAG"] = "flag";
    IssueActivityEditableProperty["TITLE"] = "title";
})(IssueActivityEditableProperty = exports.IssueActivityEditableProperty || (exports.IssueActivityEditableProperty = {}));
const createActivity = (title, staffId, type, activityInfo) => {
    return {
        title,
        staffId,
        type,
        activityInfo,
        activityDate: (0, moment_timezone_1.default)(),
    };
};
exports.createActivity = createActivity;
const getRaisedIssueActivity = (staffId, title) => {
    return {
        title: `Raised '${title}'`,
        activityDate: (0, moment_timezone_1.default)(),
        staffId,
        type: ActivityType_1.default.RAISED,
        activityInfo: {
            issueTitle: title,
        },
    };
};
exports.getRaisedIssueActivity = getRaisedIssueActivity;
const getAssignedIssueActivity = (staffId, fromId, fromSPT, toId, toSPT
// eslint-disable-next-line max-params
) => {
    return {
        title: fromId && toId ? 'Reassigned issue' : fromId ? 'Unassigned issue' : 'Assigned issue',
        activityDate: (0, moment_timezone_1.default)(),
        staffId,
        type: ActivityType_1.default.ASSIGNED,
        activityInfo: {
            fromSPT,
            fromSPTId: fromId,
            toSPT,
            toSPTId: toId,
        },
    };
};
exports.getAssignedIssueActivity = getAssignedIssueActivity;
const getCommentActivity = (staffId, activityType, commentTitle) => {
    const verb = activityType === ActivityType_1.default.ADD_COMMENT
        ? 'Added'
        : activityType === ActivityType_1.default.EDIT_COMMENT
            ? 'Edited'
            : 'Deleted';
    const titleBit = commentTitle ? ` '${commentTitle}'` : '';
    return {
        title: `${verb} a comment${titleBit}`,
        activityDate: (0, moment_timezone_1.default)(),
        staffId,
        type: activityType,
        activityInfo: {
            title: commentTitle,
        },
    };
};
exports.getCommentActivity = getCommentActivity;
const labelForEditableIssueProperty = (p) => {
    switch (p) {
        case IssueActivityEditableProperty.DEADLINE_DATE:
            return 'Deadline Date';
        case IssueActivityEditableProperty.FLAG:
            return 'Flag';
        case IssueActivityEditableProperty.STATUS:
            return 'Status';
        case IssueActivityEditableProperty.TITLE:
            return 'Title';
        case IssueActivityEditableProperty.TYPE:
            return 'Issue Type';
    }
};
const getEditIssueActivity = (staffId, what, from, to) => {
    const whatLabel = labelForEditableIssueProperty(what);
    const title = from && to
        ? `Changed ${whatLabel} from '${from}' to '${to}'`
        : from
            ? `Removed ${whatLabel}: '${from}'`
            : `Added ${whatLabel}: '${to}'`;
    return {
        title,
        activityDate: (0, moment_timezone_1.default)(),
        staffId,
        type: ActivityType_1.default.EDITED,
        activityInfo: {
            what,
            from,
            to,
        },
    };
};
exports.getEditIssueActivity = getEditIssueActivity;
